/** Clinic setup field rules, aligned with backend ClinicRegisterRequest / _validate_password. */

export function isWorkEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
}

export function clinicPasswordIssue(password) {
  const p = String(password || '');
  if (p.length < 8) return 'Use at least 8 characters.';
  if (p.trim() !== p) return 'Do not start or end with a space.';
  if (p === p.toLowerCase() || p === p.toUpperCase()) {
    return 'Include a capital letter and a lowercase letter.';
  }
  if (!/\d/.test(p)) return 'Include a number.';
  return null;
}

export function clinicRegisterIssues({ name, admin_name, admin_email, password }) {
  const issues = {};
  if (String(name || '').trim().length < 2) {
    issues.name = 'Clinic name needs at least 2 characters.';
  }
  if (!String(admin_name || '').trim()) {
    issues.admin_name = 'Add your name as it should appear on referrals.';
  }
  if (!isWorkEmail(admin_email)) {
    issues.admin_email = 'Use a work email like you@clinic.org.';
  }
  const pw = clinicPasswordIssue(password);
  if (pw) issues.password = pw;
  return issues;
}

export function clinicJoinIssues({ invite_code, name, email, password }) {
  const issues = {};
  if (String(invite_code || '').trim().length < 4) {
    issues.invite_code = 'Paste the invite code from your clinic admin.';
  }
  if (!String(name || '').trim()) {
    issues.name = 'Add your name.';
  }
  if (!isWorkEmail(email)) {
    issues.email = 'Use a work email like you@clinic.org.';
  }
  const pw = clinicPasswordIssue(password);
  if (pw) issues.password = pw;
  return issues;
}

export function clinicLoginIssues({ email, password }) {
  const issues = {};
  if (!isWorkEmail(email)) {
    issues.email = 'Use the work email on this clinic.';
  }
  if (String(password || '').length < 8) {
    issues.password = 'Password is at least 8 characters.';
  }
  return issues;
}

export function firstIssue(issues) {
  const values = Object.values(issues || {}).filter(Boolean);
  return values[0] || null;
}
